module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "login__container ui middle aligned center aligned grid"
  }, [_c('div', {
    staticClass: "column"
  }, [_vm._m(0), _vm._v(" "), _c('form', {
    staticClass: "ui large form",
    class: {
      'error': _vm.hasErrors
    }
  }, [_c('div', {
    staticClass: "ui stacked segment"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "ui left icon input"
  }, [_c('i', {
    staticClass: "user icon"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.email),
      expression: "email",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "email",
      "name": "email",
      "placeholder": "Email",
      "required": ""
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "ui left icon input"
  }, [_c('i', {
    staticClass: "lock icon"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.password),
      expression: "password",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "password",
      "name": "password",
      "placeholder": "Password",
      "required": ""
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('button', {
    staticClass: "ui fluid large black submit button",
    class: {
      'loading': _vm.isLoading
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.login($event)
      },
      "click": function($event) {
        $event.preventDefault();
        _vm.login($event)
      }
    }
  }, [_vm._v("Login")])]), _vm._v(" "), (_vm.hasErrors) ? _c('div', {
    staticClass: "ui error message"
  }, _vm._l((_vm.errors), function(error) {
    return _c('p', [_vm._v(_vm._s(error))])
  })) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "ui message"
  }, [_vm._v("\n             New to Slack? "), _c('router-link', {
    attrs: {
      "to": "/register"
    }
  }, [_vm._v("Register")])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "ui header"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("../assets/Slack_icons.svg")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n                Slack Clone\n            ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-41e5f6df"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Login.vue
// module id = 222
// module chunks = 1